import React, { useState, useEffect, useId, useMemo } from 'react';
import Chart from "react-apexcharts";
import ApexCharts from "apexcharts";
import { Typography } from '@mui/material';

import Progress from '../item/progress'

import { FONT_COLOR } from '../const/general'

export default function TyphoonLine(props) {

    const [categoryDates, setCategoryDates] = useState([]);
    const [lineData, setLineData] = useState([]);
    const [seriesMax, setSeriesMax] = useState(0);
    const [riskPoints, setRiskPoints] = useState([]);
    const [isNoData, setIsNoData] = useState(false);

    // チャートごとの一意のキー
    const chartId = useId();

    const aryMax = function (a, b) { return Math.max(a, b); }

    // チャート情報を格納
    const setChartData = (date_ary, chart_data) => {

        setCategoryDates(date_ary);
        setLineData(chart_data);

        if (chart_data.length > 0) {
            // 最大値を取得
            setSeriesMax(props.limitVal + 1)
            if (chart_data.length > 0 && chart_data.reduce(aryMax) > props.limitVal) {
                setSeriesMax(chart_data.reduce(aryMax))
            }
            setRiskPoints(props.getPoints(date_ary, chart_data))
        }
    }

    // ローディング終了
    const loadingEnd = () => {
        props.setReady(prev => {
            const updated = { ...prev };
            props.isReadyKey.forEach(key => {
                if (key in updated) {
                    updated[key] = true;
                }
            });
            return updated;
        });
    }

    // データ更新が完了したらローディング終了
    useEffect(() => {
        if (lineData !== null) {
            const timer = setTimeout(() => {
                loadingEnd();
            }, 0);
            return () => clearTimeout(timer);
        }
    }, [lineData]);

    useEffect(() => {
        // console.log('props.chartData',props.chartData)
        if (props.dateArray === null ||
            props.chartData === null) {
            setIsNoData(true)
            // console.log('loadingEnd')
            loadingEnd()
            return
        }
        if (props.dateArray && props.dateArray.length > 0
            && props.chartData && props.chartData.length > 0) {
            setChartData(props.dateArray, props.chartData)
        }
        setIsNoData(false)

    }, [props.dateArray, props.chartData]);

    useEffect(() => {
        // console.log('props.chartData',props.chartData)
        if (props.dateArray === null ||
            props.chartData === null) {
            setIsNoData(true)
            // console.log('loadingEnd')
            loadingEnd()
            return
        }
        if (props.dateArray && props.dateArray.length > 0
            && props.chartData && props.chartData.length > 0) {
            setChartData(props.dateArray, props.chartData)
        }
        setIsNoData(false)

        return () => {
            ApexCharts.exec(chartId, 'destroy'); // 明示的に破棄
        };
    }, []);


    const series = useMemo(() => {
        return [
            {
                name: props.seriesName,
                type: 'line',
                data: lineData
            },
        ];
    }, [lineData]);

    const options = useMemo(() => ({
        chart: {
            id: chartId,
            toolbar: {
                show: false,
                offsetY: 0
            },
            type: "line",
            stacked: false
        },
        // ポイントの数値表示
        dataLabels: {
            enabled: true,
            enabledOnSeries: [0],
            offsetY: -10,
            style: {
                fontSize: '8px',
                colors: ['white']
            },
            background: {
                enabled: false,
            }
        },
        colors: props.colors,
        stroke: {
            width: [2],
            colors: props.strokeColors
        },
        annotations: {
            yaxis: props.annotations ? [props.annotations] : [],
            xaxis: [
                {
                    x: categoryDates[props.chooseNum],
                    borderColor: '#0000FF',
                    borderWidth: 1,
                    strokeDashArray: 4,
                    label: {
                        show: false,
                    }
                }
            ],
            points: riskPoints
        },
        xaxis: {
            categories: categoryDates,
            labels: {
                rotate: -45,
                rotateAlways: true,
                style: {
                    colors: FONT_COLOR,
                    fontSize: '10px',
                },
            },
        },
        yaxis: [
            {
                opposite: true,
                min: -30,
                max: seriesMax,
                seriesName: props.seriesName,
                axisTicks: {
                    show: false
                },
                axisBorder: {
                    show: false,
                },
                labels: {
                    show: false,
                },
                lines: {
                    show: false
                },
            },
        ],
        tooltip: {
            shared: props.shared,
            intersect: props.intersect,
            x: {
                show: false
            },
            y: {
                formatter: props.format
            }
        },
        grid: {
            show: false, // 全体の罫線を消す
            padding: {
                left: 40,
                right: 2,
                top: -10,
                bottom: props.bottom
            }
        },
        legend: {
            show: false,
            height: 0,
        }
    }), [riskPoints, categoryDates, seriesMax, props.chooseNum]);

    // チャートのデータが更新されtら強制再描画
    useEffect(() => {
        if (series && series.length > 0) {
            ApexCharts.exec(chartId,
                "updateSeries", series);
        }
    }, [series]);

    return (
        <>
            {!props.isReadyFlg ?
                <Progress />
                // <ChartSkeleton />
                :
                isNoData ?
                    <Typography
                        sx={{
                            fontSize: '0.75rem',
                            fontWeight: 'bold',
                            color: 'white',
                        }}
                    >
                        対象データがありません
                    </Typography>
                    :
                    <Chart
                        options={options}
                        series={series}
                        height="100%"
                        width="100%"
                        style={{ visibility: props.isReadyFlg ? 'visible' : 'hidden' }}
                    />
            }
        </>
    );
}